import { getDailyReportName } from 'components/waste-management/common/helpers'
import {
  AccompanyingNoteItem,
  AccompanyingNotePostPayloadItem
} from 'components/waste-management/interfaces'

export const toWasteReportsOptions = (wasteReports: any[]) =>
  wasteReports.map(report => ({
    label: getDailyReportName(report),
    value: report.id
  }))

export const toAccompanyingNotePayload = (
  values: AccompanyingNoteItem
): AccompanyingNotePostPayloadItem => ({
  wasteCollectionCompanyId: +values.company.value,
  reportsIdList: values.wasteReports?.map(report => report.value),
  wasteCollectionCompanyDeliveryAddress: {
    id: "",
    address: values.wasteCollectionCompanyDeliveryAddress
  },
  delegate: {
    id: values.delegateId,
    name: values.delegateName,
    cnp: values.cnp,
    identityCardSeries: values.identityCardSeries,
    identityCardNumber: values.identityCardNumber,
    identityCardIssuer: values.identityCardIssuer,
    vehicleType: values.vehicleType,
    vehicleNumber: values.vehicleNumber
  }
})
